export const FETCH_CUSTOM_PRICING_TEMPLATES_PENDING = 'FETCH_CUSTOM_PRICING_TEMPLATES_PENDING';
export const FETCH_CUSTOM_PRICING_TEMPLATES_SUCCESS = 'FETCH_CUSTOM_PRICING_TEMPLATES_SUCCESS';
export const FETCH_CUSTOM_PRICING_TEMPLATES_FAILED = 'FETCH_CUSTOM_PRICING_TEMPLATES_FAILED';

export const FETCH_CUSTOM_PRICING_TEMPLATE_DETAIL_PENDING = 'FETCH_CUSTOM_PRICING_TEMPLATE_DETAIL_PENDING';
export const FETCH_CUSTOM_PRICING_TEMPLATE_DETAIL_SUCCESS = 'FETCH_CUSTOM_PRICING_TEMPLATE_DETAIL_SUCCESS';
export const FETCH_CUSTOM_PRICING_TEMPLATE_DETAIL_FAILED = 'FETCH_CUSTOM_PRICING_TEMPLATE_DETAIL_FAILED';

export const DELETE_CUSTOM_PRICING_TEMPLATE_SUCCESS = 'DELETE_CUSTOM_PRICING_TEMPLATE_SUCCESS';
